import { Wrapper } from '@american-autonomy/ag-ui';

import Grid from 'components/Grid';
import ErrorButton from 'components/buttons/ErrorButton';
import PrimaryButton from 'components/buttons/PrimaryButton';
import SuccessButton from 'components/buttons/SuccessButton';
import Panel from 'components/containers/Panel';
import CaptionText from 'components/text/CaptionText';
import ParagraphText from 'components/text/ParagraphText';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { ConfirmVariant, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CONFIRM_BUTTON: Record<
    ConfirmVariant,
    FunctionComponent<{ className?: string; onClick?: VoidFunction; text: string }>
> = {
    error: ErrorButton,
    success: SuccessButton
};

const ConfirmationModal: FunctionComponent<Props> = ({
    className = '',
    confirmText,
    confirmVariant = 'error',
    onBack,
    onConfirm,
    subText,
    testId = TEST_ID,
    text
}) => {
    const { BACK_BUTTON_TEXT } = useTranslation();

    const ConfirmButton = CONFIRM_BUTTON[confirmVariant];

    return (
        <Panel className={`${className} ${styles.panel}`} testId={testId}>
            <Wrapper className={styles.wrapper}>
                <ParagraphText className={styles.paragraphText} text={text} />

                {subText && <CaptionText className={styles.captionText} text={subText} />}
            </Wrapper>

            <Grid className={styles.grid}>
                <PrimaryButton
                    className={styles.primaryButton}
                    onClick={onBack}
                    text={BACK_BUTTON_TEXT}
                />

                <ConfirmButton
                    className={styles.confirmButton}
                    onClick={onConfirm}
                    text={confirmText}
                />
            </Grid>
        </Panel>
    );
};

export default ConfirmationModal;
